import { useFeed } from "../hooks/useFeed";
import { PanelHeader } from "./PanelHeader";
import type { ParkingZone } from "@kmitl/shared";

const API_BASE = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? "";

const TYPE_LABEL: Record<ParkingZone["type"], string> = {
  car:        "CAR",
  motorcycle: "MOTO",
  covered:    "CVD",
  staff:      "STAFF",
};

function fillColor(rate: number, status: ParkingZone["status"]): string {
  if (status === "closed") return "var(--text-3)";
  if (status === "full")   return "var(--bad)";
  if (rate >= 80) return "var(--warn)";
  if (rate >= 50) return "var(--data)";
  return "var(--good)";
}

export function ParkingPanel() {
  const feed = useFeed<ParkingZone>(`${API_BASE}/api/campus/parking`, 2 * 60_000);
  const zones = feed.data;

  const totalCars = zones.filter(z => z.type === "car" || z.type === "covered" || z.type === "staff");
  const availCars = totalCars.reduce((s, z) => s + z.availableSpaces, 0);
  const totalCarSpaces = totalCars.reduce((s, z) => s + z.totalSpaces, 0);

  return (
    <div className="parking-panel left-section">
      <PanelHeader
        title="PARKING AVAILABILITY"
        ageMinutes={feed.ageMinutes}
        fallbackTier={feed.fallbackTier === "loading" ? undefined : feed.fallbackTier}
        source="kmitl-parking"
      />
      <div className="parking-summary mono">
        <span style={{ color: availCars === 0 ? "var(--bad)" : "var(--good)" }}>
          {availCars}
        </span>
        <span className="parking-summary-of"> / {totalCarSpaces} spaces free (cars)</span>
      </div>
      <div className="parking-list">
        {zones.map((z) => {
          const rate = z.fillRate ?? 0;
          const color = fillColor(rate, z.status);
          return (
            <div key={z.id} className="parking-row" title={`${z.name.en}: ${z.availableSpaces}/${z.totalSpaces} free`}>
              <span className="parking-type-chip mono">{TYPE_LABEL[z.type]}</span>
              <span className="parking-name mono">{z.name.en}</span>
              <div className="parking-bar-track">
                <div
                  className="parking-bar-fill"
                  style={{ width: `${rate}%`, background: color }}
                />
              </div>
              <span className="parking-avail mono" style={{ color }}>
                {z.status === "closed" ? "CLSD" : z.status === "full" ? "FULL" : z.availableSpaces}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
